import { render, staticRenderFns } from "./ProductTranslationNewPopup.vue?vue&type=template&id=5dbccd52&"
import script from "./ProductTranslationNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProductTranslationNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports